
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/toaster";
import { HelmetProvider } from "react-helmet-async";
import Router from "./Router";
import TopBar from "@/components/TopBar";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "./App.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <GoogleReCaptchaProvider reCaptchaKey="6LePh_MrAAAAABm1C7GjMdWE3Q55BZoPPeDChjfM">
            <AuthProvider>
              <CartProvider>
                <ScrollToTop />
                <div className="min-h-screen flex flex-col relative">
                  <div className="fixed top-0 z-50 w-full">
                    <TopBar />
                    <NavBar />
                  </div>
                  <main className="flex-1 bg-white pt-28">
                    <div className="container mx-auto px-4 pb-16">
                      <Router />
                    </div>
                  </main>
                  <Footer />
                </div>
                <Toaster />
              </CartProvider>
            </AuthProvider>
          </GoogleReCaptchaProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
